import React from "react";
import FieldTooltip from "./FieldTooltip";

export default function FieldLabel({
  children,
  required = false,
  tooltip,
  htmlFor,
  className = "",
  tooltipPlacement = "top",
}) {
  return (
    <div
      className={["oh-field-label-row", className].filter(Boolean).join(" ")}
    >
      <label htmlFor={htmlFor} className="oh-field__label form-label mb-0">
        {children}
        {required ? <span className="text-danger"> *</span> : null}
      </label>
      {tooltip ? (
        <FieldTooltip content={tooltip} placement={tooltipPlacement} />
      ) : null}
    </div>
  );
}
